import { FC } from "react";
import { Text, Textarea, Group } from "@mantine/core";
import { useStyles } from "../Regtank.styles";
import { Button } from "@funded-here-interface/common";
import {
  BUTTON_STYLES,
  BUTTON_LABELS,
  SECTION_HEADINGS,
  INSTRUCTION_TEXT,
} from "../Regtank.constants";

interface ReattemptApprovalFormProps {
  remark: string;
  onRemarkChange: (value: string) => void;
  onApprove: () => void;
  onReject: () => void;
  approveButtonDisabled: boolean;
  rejectButtonDisabled: boolean;
}

/**
 * Reusable reattempt approval form component
 * Used for both onboarding and liveness verification
 */
export const ReattemptApprovalForm: FC<ReattemptApprovalFormProps> = ({
  remark,
  onRemarkChange,
  onApprove,
  onReject,
  approveButtonDisabled,
  rejectButtonDisabled,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.div}>
      <Text className={classes.header}>
        {SECTION_HEADINGS.reattemptApproval}
      </Text>
      <Text className={classes.instruction}>
        {INSTRUCTION_TEXT.reattemptApproval}
      </Text>
      <Textarea
        value={remark}
        autosize
        minRows={2}
        maxRows={4}
        onChange={(e) => onRemarkChange(e.target.value)}
      />
      <Group mt="xl" position="left">
        <Button
          disabled={approveButtonDisabled}
          onClick={onApprove}
          backgroundColor={BUTTON_STYLES.approve.backgroundColor}
          textColor={BUTTON_STYLES.approve.color}
          width="100px"
        >
          {BUTTON_LABELS.approve}
        </Button>
        <Button
          disabled={rejectButtonDisabled}
          onClick={onReject}
          backgroundColor={BUTTON_STYLES.reject.backgroundColor}
          textColor={BUTTON_STYLES.reject.color}
          width="100px"
        >
          {BUTTON_LABELS.reject}
        </Button>
      </Group>
    </div>
  );
};